/**
 * Okna miesięczne harmonogramu pojazdu (`CarSchedule`).
 *
 * Od 29.09.2026 karta auta i harmonogram floty czytają plan pracy
 * (`vehiclePlanApi.ts`), który sam oznacza okna niedostępności
 * (`PlanMonth.unavailable`). Lista statusów zostaje tu jako kopia
 * pilnowana testem zgodności z backendem.
 */

/**
 * Statusy okna oznaczające, że auto NIE jest w tym miesiącu do dyspozycji.
 *
 * Kopia listy z `car-schedule-offers.service.ts` — tam jest lista wykluczeń,
 * nie biała lista, bo źródło po kilku wpadkach z białą listą z niej zeszło.
 * Zgodności pilnuje test.
 */
export const UNAVAILABLE_STATUSES = [
  'unavailable',
  'Niedostępny',
  'maintenance',
  'Serwis',
];

export function isUnavailable(status: unknown): boolean {
  return typeof status === 'string' && UNAVAILABLE_STATUSES.includes(status);
}

/**
 * Status okna do wyświetlenia (poprawa brzmienia 01.10.2026). W bazie bywa
 * po angielsku (`maintenance`, `unavailable` — z FreightFusion) i po polsku
 * wielką literą; wartość zostaje, na ekran idzie jedna polska etykieta.
 * Status spoza listy — tak, jak jest.
 */
const STATUS_LABELS: ReadonlyMap<string, string> = new Map([
  ['maintenance', 'serwis'],
  ['Serwis', 'serwis'],
  ['unavailable', 'niedostępny'],
  ['Niedostępny', 'niedostępny'],
]);

export function scheduleStatusLabel(status: string): string {
  return STATUS_LABELS.get(status) ?? status;
}

/** Dymek zakreskowanego miesiąca na osi — pełnym zdaniem. */
export function unavailableMonthTitle(status: string): string {
  const label = scheduleStatusLabel(status);
  if (label === 'serwis') return 'W tym miesiącu pojazd jest w serwisie.';
  if (label === 'niedostępny') return 'W tym miesiącu pojazd jest niedostępny.';
  return `W tym miesiącu pojazd jest niedostępny (${label}).`;
}
